import './styles.scss';
import * as React from 'react';
import {Component} from 'react';
import {createClassName} from '../../util/utility';
import {ProgressBar} from 'react-bootstrap';
import {compose} from 'redux';
import {connect} from 'react-redux';

export interface StatusbarProps {
  className?: string;
  totalSteps?: number;
  currentSteps?: number;
  gradient?: boolean;
  buStyles: any;
}

const Statusbar = ({
  className,
  totalSteps,
  currentSteps,
  gradient,
  buStyles,
}: StatusbarProps) => {
  const primaryColor = buStyles.primaryColor || '#00DFE9'
  const hoverColor = buStyles.hoverColor || '#0085B9'
  const classes = createClassName('progress', className);
  let currentValue = 0;

  if (totalSteps && totalSteps > 0) {
    if (currentSteps) {
      currentValue = (currentSteps / totalSteps) * 100;
    }
  }

  const ProgressBarCustomStyle = () => (
    <style type="text/css">
      {`
        .progress-bar.bg-custom {
          background-color: ${primaryColor};
          background: linear-gradient(134.06deg, ${primaryColor} 0%, ${hoverColor} 100%)
        }
      `}
    </style>
  )

  return (
    <>
      {ProgressBarCustomStyle()}
      <ProgressBar
        className={classes}
        now={currentValue}
        variant="custom"
      />
    </>
  );
};

const mapStateToProps = ({globalStyles}: any) => ({
  buStyles: globalStyles.value,
});

export default compose(connect(mapStateToProps)(Statusbar));
